import SectionHeading from "@/components/base/SectionHeading";
import { synopsis } from "@/mocks/homeContent";

export default function Synopsis() {
  return (
    <section id="synopsis" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading kicker="Story Overview" title={synopsis.title} desc={synopsis.oneLine} />

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.35fr_1fr]">
          <div className="space-y-5">
            <p className="border-l-2 border-primary-400 bg-primary-50 px-5 py-4 text-sm leading-relaxed text-foreground-800 md:text-base">
              {synopsis.lead}
            </p>
            {synopsis.paragraphs.map((para, index) => (
              <p key={index} className="text-sm leading-7 text-foreground-600 md:text-[15px]">
                {para}
              </p>
            ))}
          </div>

          <div className="space-y-5">
            <div className="overflow-hidden rounded-lg border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20a%20warm%20empty%20room%20at%20dusk%2C%20soft%20amber%20lamp%20light%20through%20sheer%20curtains%2C%20blurred%20window%20with%20rain%2C%20muted%20cream%20and%20terracotta%20tones%2C%20painterly%20grainy%20texture%2C%20melancholic%20calm%20literary%20mood%2C%20no%20people%2C%20high%20detail&width=1200&height=900&seq=nfw-atmos-window-01&orientation=landscape"
                alt=""
                className="h-52 w-full object-cover object-top md:h-60"
              />
            </div>
            <div className="rounded-lg border border-background-200/70 bg-background-100 p-5">
              <p className="text-xs leading-relaxed text-foreground-600">
                提示：网络流传版本较多，章节与结局存在差异。以上梗概整理自各版本中较为共识的主线，仅供导读参考。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {synopsis.highlights.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors hover:border-primary-200"
            >
              <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}